import Box from "@mui/material/Box";

import { PRODUCTS_MENU_DIVIDER_IMAGE } from "../navbar.config";
import { useNavProducts } from "../navbar.hooks";
import ServiceTile from "../ServiceTile";
import MenuCard from "./MenuCard";

/*
 * Financing products. The individuals catalogue is long enough to want two
 * columns; the companies one is two entries and reads better in a single one.
 *
 * The product list is resolved here rather than in the bar above so that the
 * localStorage fallback is only read when the menu is actually opened.
 */
export default function ProductsMenu({
  allProduct,
  isCompanyAudience,
  onNavigate,
}) {
  const products = useNavProducts(allProduct, { isCompanyAudience });

  return (
    <MenuCard dividerImage={PRODUCTS_MENU_DIVIDER_IMAGE} dividerWidth="110%">
      <Box
        sx={{
          overflow: "auto",
          p: isCompanyAudience ? 1 : 2,
          display: isCompanyAudience ? "block" : "grid",
          gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
          columnGap: 0,
        }}
      >
        {products.map(({ id, title, img, url }) => (
          <ServiceTile
            key={id || url}
            url={url}
            title={title}
            img={img}
            onNavigate={onNavigate}
          />
        ))}
      </Box>
    </MenuCard>
  );
}
